<template>
  <v-card
    v-if="
      processDisplaySystem !== null &&
      typeof processDisplaySystem !== 'undefined'
    "
  >
    <v-card-title>Settings</v-card-title>
    <v-card-subtitle
      >Config this Process Display System. This will change all this instance on
      all devices.</v-card-subtitle
    >
    <v-list>
      <v-list-item v-for="(uiField, index) in configFields" :key="index">
        <v-col>
          <v-list-item-title>{{ uiField.label }}</v-list-item-title>
        </v-col>
        <v-col>
          <UiField :field="uiField" @fieldInput="fieldInput" ref="uiField" />
        </v-col>
      </v-list-item>
    </v-list>
    <v-card-text>
      <v-banner
        v-if="
          errorMessage !== null &&
          typeof errorMessage !== 'undefined' &&
          errorMessage !== ''
        "
        color="error"
      >
        {{ errorMessage }}
      </v-banner>
    </v-card-text>

    <v-card-actions class="justify-space-between">
      <v-btn
        text
        color="error"
        x-large
        @click="cancel"
        :disabled="isButtonDisabled('cancelButton')"
        :loading="isButtonLoading('cancelButton')"
      >
        Cancel
      </v-btn>
      <v-btn
        color="primary"
        x-large
        @click="save"
        :disabled="isButtonDisabled('saveButton')"
        :loading="isButtonLoading('saveButton')"
      >
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import UiField from "./uiField";
export default {
  name: "SettingsCard",
  components: { UiField },
  data() {
    return {
      processDisplaySystemUpdateProxy: {},
      errorMessage: null,
      disabledElements: [],
      loadingElements: [],
      forceRefresh: 0,
    };
  },
  computed: {
    configFields() {
      const pds = JSON.parse(JSON.stringify(this.processDisplaySystem))
      if (pds === null || typeof pds === "undefined") {
        return [];
      }
      return [
        {
          key: "title",
          type: "textfield",
          label: "Title",
          value: pds.title,
        },
        {
          key: "showLocationVariationOnOrderCard",
          type: "switch",
          label: "Show location variation on order card",
          value: pds.showLocationVariationOnOrderCard,
        },
        {
          key: "fullscreen",
          type: "switch",
          label: "Fullscreen",
          value: this.isFullscreen,
        },
        {
          key: "darkMode",
          type: "switch",
          label: "Dark mode",
          value: pds.darkMode,
        },
      ];
    },
    locationOptions() {
      if (
        this.$store.state.locationOptions === null ||
        typeof this.$store.state.locationOptions === "undefined"
      ) {
        return [];
      }

      return this.$store.state.locationOptions.map((l) => {
        return {
          key: l.uuid,
          label: l.label,
        };
      });
    },
    channels() {
      return this.$store.state.channelOptions;
    },
    onlineChannels() {
      if (Array.isArray(this.channels)) {
        if (
          Array.isArray(this.processDisplaySystem.posChannels) &&
          Array.isArray(this.processDisplaySystem.channels)
        ) {
          return this.channels.map((c) => {
            return {
              ...c,
              key: c.uuid,
              disabled:
                this.processDisplaySystem.posChannels.some(
                  (pc) => pc && pc.uuid === c.uuid
                ) &&
                !this.processDisplaySystem.channels.some(
                  (oc) => oc && oc.uuid === c.uuid
                ),
            };
          });
        }
        return this.channels;
      }
      return [];
    },
    posChannels() {
      if (Array.isArray(this.channels)) {
        if (
          Array.isArray(this.processDisplaySystem.channels) &&
          Array.isArray(this.processDisplaySystem.posChannels)
        ) {
          return this.channels.map((c) => {
            return {
              ...c,
              key: c.uuid,
              disabled:
                this.processDisplaySystem.channels.some(
                  (oc) => oc && oc.uuid === c.uuid
                ) &&
                !this.processDisplaySystem.posChannels.some(
                  (pc) => pc && pc.uuid === c.uuid
                ),
            };
          });
        }
        return this.channels;
      }
      return [];
    },
    categoryOptions() {
      if (
        this.$store.state.categoryOptions === null ||
        typeof this.$store.state.categoryOptions === "undefined"
      ) {
        return [];
      }

      return this.$store.state.categoryOptions.map((c) => {
        return {
          key: c.uuid,
          label: c.name,
        };
      });
    },
    timeOfRedOptions() {
      const minuteArray = [];
      const startValueInMillis = 0;
      const maxValueInMillis = 7200000;
      const stepperInMillis = 60000;

      for (
        let i = startValueInMillis;
        i <= maxValueInMillis;
        i = i + stepperInMillis
      ) {
        minuteArray.push({
          key: i,
          label: i / 60000 + " minutes",
        });
      }

      return minuteArray;
    },
    timeOfYellowOptions() {
      const forceRefresh = this.forceRefresh; // eslint-disable-line
      const minuteArray = [];
      let startValueInMillis = 0;
      const maxValueInMillis = 7200000;
      const stepperInMillis = 60000;
      if (
        this.$store.state.processDisplaySystem.timeOfRed !== null &&
        typeof this.$store.state.processDisplaySystem.timeOfRed !== "undefined"
      ) {
        startValueInMillis =
          this.$store.state.processDisplaySystem.timeOfRed + stepperInMillis;
      }
      if (
        this.processDisplaySystemUpdateProxy.timeOfRed !== null &&
        typeof this.processDisplaySystemUpdateProxy.timeOfRed !== "undefined"
      ) {
        startValueInMillis =
          this.processDisplaySystemUpdateProxy.timeOfRed + stepperInMillis;
      }

      for (
        let i = startValueInMillis;
        i <= maxValueInMillis;
        i = i + stepperInMillis
      ) {
        minuteArray.push({
          key: i,
          label: i / 60000 + " minutes",
        });
      }

      return minuteArray;
    },
    isFullscreen: {
      get: function () {
        const forceRefresh = this.forceRefresh; //eslint-disable-line
        return !!(
          document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement ||
          document.msFullscreenElement
        );
      },
      set: function (value) {
        if (value) {
          const elem = document.documentElement;
          if (elem.requestFullscreen) {
            elem.requestFullscreen().then(() => {
              this.forceRefresh++;
            });
          } else if (elem.webkitRequestFullscreen) {
            /* Safari */
            elem.webkitRequestFullscreen().then(() => {
              this.forceRefresh++;
            });
          } else if (elem.msRequestFullscreen) {
            /* IE11 */
            elem.msRequestFullscreen().then(() => {
              this.forceRefresh++;
            });
          }
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen().then(() => {
              this.forceRefresh++;
            });
          } else if (document.webkitExitFullscreen) {
            /* Safari */
            document.webkitExitFullscreen().then(() => {
              this.forceRefresh++;
            });
          } else if (document.msExitFullscreen) {
            /* IE11 */
            document.msExitFullscreen().then(() => {
              this.forceRefresh++;
            });
          }
        }
      },
    },
    processDisplaySystem() {
      return this.$store.state.processDisplaySystem;
    },
  },
  methods: {
    showError(message) {
      this.errorMessage = message;
    },
    fieldInput(field) {
      if (field.key === "darkMode") {
        this.$vuetify.theme.dark = field.value;
      }
      if (field.key === "fullscreen") {
        this.isFullscreen = field.value;
      } else {
        this.forceRefresh += 1;
        const nestingLayers = field.key.split(".");
        let reference = this.processDisplaySystemUpdateProxy;
        for (let n = 0; n < nestingLayers.length; n++) {
          const currentKey = nestingLayers[n];

          if (n + 1 === nestingLayers.length) {
            reference[currentKey] = field.value;
          } else {
            if (
              reference[currentKey] === null ||
              typeof reference[currentKey] === "undefined"
            ) {
              reference[currentKey] = {};
            }
            reference = reference[currentKey];
          }
        }
      }
    },
    save() {
      this.disabledElements.push("saveButton");
      this.loadingElements.push("saveButton");
      this.disabledElements.push("cancelButton");
      const pds = JSON.parse(
        JSON.stringify(this.processDisplaySystemUpdateProxy)
      );
      this.$store.dispatch("updateProcessDisplaySystem", pds).then((res) => {
        this.disabledElements = [];
        this.loadingElements = [];
        if (res !== null && typeof res !== "undefined") {
          this.$emit("saved");
          this.$emit("closed");
        } else {
          this.showError("Something went wrong with saving.");
        }
      });
    },
    cancel() {
      if (Array.isArray(this.$refs.uiField)) {
        for (let i = 0; i < this.$refs.uiField.length; i++) {
          this.$refs.uiField[i].cancel();
        }
      }
      this.processDisplaySystemUpdateProxy = {};
      this.$emit("closed");
    },
    isButtonDisabled(key) {
      return this.disabledElements.findIndex((el) => el === key) !== -1;
    },
    isButtonLoading(key) {
      return this.loadingElements.findIndex((el) => el === key) !== -1;
    },
  },
};
</script>

<style scoped></style>
